import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b031723"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "additional-content"
}

import { ref } from "vue";

type Kind = "wide" | "medium" | "full" | "short";


export default /*#__PURE__*/_defineComponent({
  __name: 'NastaPill',
  props: {
    kind: { default: "wide" }
  },
  setup(__props: any) {

const revealed = ref(false);

const toggleRevealed = () => {
  revealed.value = !revealed.value;
};

// todo: eslint?
// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pill", `pill-${_ctx.kind}${revealed.value ? ' revealed' : ''}`])
  }, [
    _createElementVNode("div", {
      class: "pill-content",
      onClick: toggleRevealed
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.$slots['additional-content'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "additional-content")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})